import { H3, Text } from '@betterment/samba-react';

export const Notices: React.FC = () => {
  return (
    <>
      <Text as="p" css={{ pb: 'space.200' }}>
        This is a written notice of the employee's rights and obligations under the plan, and the notice must meet
        certain content and timing requirements. It may include information regarding the safe harbor provision and the
        Plan's automatic enrollment feature, if applicable.
      </Text>

      <H3 variant="title100">Safe Harbor notice (if applicable)</H3>

      <Text as="p" css={{ pb: 'space.200' }}>
        This will describe the mandatory employer contributions for the upcoming plan year.
      </Text>

      <H3 variant="title100">Auto-enrollment notice (if applicable)</H3>

      <Text as="p">
        This will explain how the employer will automatically reduce an employee's wages by a default percentage stated
        in the plan document and contribute it into the employee's individual account. Generally, this must be
        distributed in a timely manner every year by December 1st of the preceding year. Additionally, this notice
        should be distributed to newly eligible employees when able to enter the plan.
      </Text>
    </>
  );
};
